'use client';

import { Card, Label } from '@repo/ui';
import { ScrollableContainer } from '../common/scrollable-container';
import { DistributionGraph } from '../common/distribution-graph';
import { IQRResult } from '../../../lib/stats/quartiles';

interface IQRCalculatorProps {
  visualizationData: IQRResult | null;
}

export function IQRCalculator({ visualizationData: result }: IQRCalculatorProps) {
  if (!result) {
    return null;
  }

  return (
    <ScrollableContainer>
      <div className="space-y-6">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Interquartile Range Results</h3>
          <div className="space-y-2">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>First Quartile (Q1)</Label>
                <div className="text-lg">{result.q1.toFixed(2)}</div>
              </div>
              <div>
                <Label>Third Quartile (Q3)</Label>
                <div className="text-lg">{result.q3.toFixed(2)}</div>
              </div>
              <div>
                <Label>Interquartile Range (IQR)</Label>
                <div className="text-lg font-semibold">{result.iqr.toFixed(2)}</div>
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Outlier Analysis</h3>
          <div className="space-y-2">
            <div>
              <Label>Lower Fence</Label>
              <div>{result.lowerFence.toFixed(2)}</div>
            </div>
            <div>
              <Label>Upper Fence</Label>
              <div>{result.upperFence.toFixed(2)}</div>
            </div>
            <div>
              <Label>Outliers Found</Label>
              <div>{result.outliers.length > 0 ? result.outliers.join(', ') : 'No outliers detected'}</div>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Distribution Plot</h3>
          <DistributionGraph
            data={[...result.nonOutliers, ...result.outliers]}
            height={300}
            showMean
            showMedian
            grid={{
              left: '10%',
              right: '5%',
              top: '10%',
              bottom: '10%'
            }}
          />
        </Card>
      </div>
    </ScrollableContainer>
  );
} 